import { render, staticRenderFns } from "./RoleListRow.vue?vue&type=template&id=114f8b55"
import script from "./RoleListRow.vue?vue&type=script&lang=ts"
export * from "./RoleListRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports